const generateUrl = (path, domain) => {
    const hasDomain = typeof domain === 'string';
    const base = hasDomain ? domain : 'http://test.com';
    const url = new URL(path, base);
    if (!hasDomain)
        return `${url.pathname}${url.search}`;
    return url.toString();
};
const decorateRelativeUrlByDomain = (path, domain) => {
    const isAbsoluteUrl = (path) => {
        try {
            // eslint-disable-next-line no-new
            new URL(path);
            return true;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        }
        catch (_) {
            return false;
        }
    };
    return isAbsoluteUrl(path) ? path : generateUrl(path, domain);
};
const makeRelAttribute = (config) => {
    if (!config?.href)
        return '';
    const withNoReferrerParams = config.href.indexOf('promo=1') > -1 || config.href.indexOf('noreferrer=1') > -1;
    // @ts-expected-error TODO исправить после обновления типизации
    const noReferrer = withNoReferrerParams || config.noReferrer ? 'noreferrer' : undefined;
    const noFollow = config.nofollow ? 'nofollow' : undefined;
    const rel = [noReferrer, noFollow].filter((tag) => tag).join(' ');
    return rel || undefined;
};

export { decorateRelativeUrlByDomain, generateUrl, makeRelAttribute };
//# sourceMappingURL=links.js.map
